'use strict';
const nodeToRectConverter = require('./node-to-rect-converter'),
	checkParams = require('@mindmup/js-utils/src/check-params'),
	RectSet = require('./rect-set'),
	Offset = require('./offset');
module.exports = function NodeTree(params) {
	checkParams(params, ['nodeDictionary', 'rootIdea']);
	let currentOffset;
	const self = this,
		{nodeDictionary, rootIdea} = params,
		positionArray = (rootIdea && rootIdea.attr && rootIdea.attr.position) || [0, 0, 0],
		priority = positionArray[2],
		rootIdeaPosition = {
			x: positionArray[0],
			y: positionArray[1]
		},
		rootNode = nodeDictionary[rootIdea.id],
		calcDesiredOffset = () => {
			if (!rootNode) {
				throw new Error('invalid-args');
			}
			const rootNodeCenterOffset = new Offset({x: Math.round(rootNode.width / -2), y: Math.round(rootNode.height / -2)}),
				startingOffset = priority ? new Offset(rootIdeaPosition) : rootNodeCenterOffset;
			return startingOffset.subtract(rootNode);
		};

	currentOffset = calcDesiredOffset();

	self.contains = nodeId => !!nodeDictionary[nodeId];

	self.extensionFrom = (point) => {
		if (!point) {
			throw new Error('invalid-args');
		}
		const nodeCenter = node => new Offset({x: node.x + (node.width / 2), y: node.y + (node.height / 2)}),
			calcNodeExtension = node => nodeCenter(node).add(currentOffset).subtract(point).extension(), //nodeExtensionFromPoint({node, point: offsetPoint}),
			nodeExtensions = Object.values(nodeDictionary).map(node => {
				return calcNodeExtension(node);
			});
		return Math.min.apply({}, nodeExtensions);
	};

	self.toRectSet = (margin) => {
		const rectangles = Object.values(nodeDictionary).map(node => {
			const parent = nodeDictionary[node.parentId];
			return nodeToRectConverter({node, margin, parent});
		});
		return new RectSet({rectangles});
	};
	self.nodeDictionaryOffset = () => {
		const result = {};

		Object.keys(nodeDictionary).forEach(key => {
			const node = nodeDictionary[key],
				newOffset = currentOffset.add(node);
			result[key] = Object.assign({}, node, {
				x: newOffset.x,
				y: newOffset.y,
				rootId: rootIdea.id
			});
		});
		return result;
	};
	self.nodeForId = (nodeId) => nodeDictionary[nodeId];
	self.setCurrentOffset = o => currentOffset = o;
	self.getCurrentOffset = () => currentOffset;
	Object.freeze(Object.assign(self, {
		rootIdea, rootNode, rootIdeaPosition, priority, nodeDictionary, currentOffset
	}));
};
